import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import { debounce } from '../../core/helpers';
import { animate } from '../../core/animations';
import sliderADA from '../../components/slider/ada';

const initSlider = (slider) => {
  const items = slider.querySelectorAll('.category-two-sides__item');
  
  const swiper = new Swiper(slider, {
    modules: [ Navigation, A11y, FreeMode ], // https://swiperjs.com/swiper-api#using-js-modules
    a11y: {
      enabled: true,
      prevSlideMessage: window.theme.strings.swiperPrevSlide,
      nextSlideMessage: window.theme.strings.swiperNextSlide,
      containerMessage: window.theme.strings.swiperContainer,
    },
    slidesPerView: 2.2,
    slidesPerGroup: 2,
    spaceBetween: 8,
    loop: false,
    loopAddBlankSlides: false,
    autoHeight: true,
    freeMode: true,
    autoplay: false,
    // navigation: false,
    breakpoints: {
      769: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        autoHeight: true,
        navigation: {
          nextEl: '.category-two-sides .swiper-button-next',
          prevEl: '.category-two-sides .swiper-button-prev',
        },
      },
      1500: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 8,
        freeMode: false,
        autoHeight: true,
        navigation: {
          nextEl: '.category-two-sides .swiper-button-next',
          prevEl: '.category-two-sides .swiper-button-prev',
        },
      }
    },
    on: {
      init: function () {
        animate();
        sliderADA(document.querySelector('.category-two-sides .swiper'));
      },
    }
  });
};

const showHideArrows = (sliders) => {
  sliders.forEach(slider => {
    const items = slider.querySelectorAll('.category-two-sides__item');
    const nextArrow = slider.closest('.category-two-sides')?.querySelector('.swiper-button-next');
    const prevArrow = slider.closest('.category-two-sides')?.querySelector('.swiper-button-prev');

    // Determine how many slides are needed for arrows based on window width
    let minSlidesForArrows = 3;
    if (window.innerWidth >= 1500) {
      minSlidesForArrows = 4;
    } else if (window.innerWidth >= 769) {
      minSlidesForArrows = 3;
    } else {
      minSlidesForArrows = Infinity; // Hide arrows on mobile
    }

    if (items.length >= minSlidesForArrows) {
      if (nextArrow) nextArrow.style.display = '';
      if (prevArrow) prevArrow.style.display = '';
    } else {
      if (nextArrow) nextArrow.style.display = 'none';
      if (prevArrow) prevArrow.style.display = 'none';
    }
  });
};

export default () => {
  const sliders = document.querySelectorAll('.category-two-sides .swiper');
  if (!document.querySelector('.category-two-sides') || sliders.length === 0) {
    return;
  }

  sliders.forEach(slider => {
    initSlider(slider);
  });

  showHideArrows(sliders);
  
  window.addEventListener('resize', debounce(() => {
    showHideArrows(sliders);
  }, 100));
};
